import type { JobQueryParams } from "api/resources/hire";
import { queries as jobListQueries } from "domains/hire/containers/JobList/queries";
import type { WarmableQuery } from "routing/warmQueries";

export const queries = (input: { search: JobQueryParams }): Array<WarmableQuery> => jobListQueries(input);
